import React from 'react'
import styled from 'styled-components'
import CommentForm from './CommentForm';
import { CommentsApi } from '../../API/api'
import { GA_Event } from '../Analytics/Analytics'

const Container = styled.div`
border-bottom:1px solid rgba(103, 103, 103, .45);
display:flex;
flex-direction:column;
text-align:center;
justify-content:flex-start;
padding-bottom:10px;
margin-bottom:10px;
> *{
    width:100%;
    margin-bottom:10px;
 }
 @media screen and (min-width: 750px) {
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
    text-align:right;
     > *{
        width:auto;
        margin-bottom:0;
     }
    }
    
    `
const NewCommentLabel = styled.label`
color: #33354a;
`
const NewCommentButton = styled.button`
padding: 8px 20px 5px;
background-color: #33354a;
color: #fff;
cursor: pointer;
margin: ${props => props.center ? 'auto' : 'unset'};
`

const CommentCountLabel = styled.label`
order: -1;
@media screen and (min-width: 750px) {
    
    order:0;
    
}
`
const NewCommentTag = (props) => {
    return props.show ? (<NewCommentLabel>כתוב תגובה חדשה</NewCommentLabel>) :
        (<NewCommentButton center={!props.showCommentCount} onClick={props.btnOnClick}>הוסף תגובה חדשה</NewCommentButton>)
}
class CommentsTopBar extends React.Component {
    constructor() {
        super();
        this.showMainForm = this.showMainForm.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        
        this.state = {
            isMainFormActive: false,
            formState: { msg: 'חובה להזין שם', valid: false },
            inputName: '',
            inputTitle: '',
            inputContent: ''
        }
    }
    showMainForm() {
        GA_Event('Add_Comment', window.location.pathname + window.location.hash);
        this.setState({
            isMainFormActive: true
        });
    }
    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
        window.setTimeout(() => {
            this.setState({
                formState: this.validateForm()
            });
        }, 0);
    }
    handleSubmit(event) {
        event.preventDefault();
        if (!this.state.formState.valid) {
            alert(this.state.formState.msg);
            return;
        }
        this._submitForm();
        this.setState({
            inputName: '',
            inputTitle: '',
            inputContent: '',
            isMainFormActive: false,
            formState: { msg: 'חובה להזין שם', valid: false }
        });
    }
    _submitForm() {
        CommentsApi.add(
            this.state.inputName,
            this.state.inputTitle,
            this.state.inputContent,
            this.props.articleRef
        );
        alert('תודה, קיבלנו את תגובתך ונשתדל לפרסמה בכפוף לשיקולי המערכת.');
    }
    validateForm() {
        let result = {
            msg: '',
            valid: true
        };
        const _name = this.state.inputName;
        const _title = this.state.inputTitle;
        if (_name.length < 1) {
            result.msg = 'חובה להזין שם';
            result.valid = false;
            return result;
        }
        if (_title.length < 1) {
            result.msg = 'חובה להזין כותרת';
            result.valid = false;
            return result;
        }
        return result;
    }

    render() {
        return (
            <div>
                <div>
                    <Container>
                        <NewCommentTag showCommentCount={this.props.showCommentCount} show={this.state.isMainFormActive} btnOnClick={this.showMainForm} />
                        {this.props.showCommentCount ?
                            <CommentCountLabel>
                                לכתבה זו התפרסמו <span>{this.props.commentCount} תגובות</span>
                            </CommentCountLabel>
                            : ""}
                    </Container>
                </div>
                <CommentForm
                    isActive={this.state.isMainFormActive}
                    isValid={this.state.formState.valid}
                    handleChange={this.handleInputChange}
                    inputName={this.state.inputName}
                    inputTitle={this.state.inputTitle}
                    inputContent={this.state.inputContent}
                    handleSubmit={this.handleSubmit}
                />
            </div>
        )
    }
}

export default CommentsTopBar;


// WEBPACK FOOTER //
// ./src/Components/comments/CommentsTopBar.jsx